import React, { useState } from 'react';
import './Login.css';
import logo from '../assets/Zenio+Logo+header.png';
import { api } from '../services/api';
import { GoogleLogin } from '@react-oauth/google';

function Login({ onLogin }) {
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    setIsLoading(true);

    try {
      const result = await api.googleLogin(credentialResponse.credential);
      
      if (result.success && result.user) {
        onLogin(result.user);
      } else {
        setError(result.message || 'Google login failed. Please ensure your email is from the authorized organization.');
      }
    } catch (error) {
      console.error('Google login error:', error);
      setError('Google login failed. Please try again or contact your administrator.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError('Google login failed. Please try again.');
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="logo-container">
          <div className="logo-backdrop">
            <img src={logo} alt="ZenIO Logo" className="company-logo-img" />
          </div>
          <h2>Company Portal</h2>
          <p style={{ 
            color: '#ffffff9a', 
            fontSize: '14px', 
            marginTop: '10px',
            marginBottom: '30px'
          }}>
            Sign in with your company Google account
          </p>
        </div>

        {error && (
          <div className="error-message" style={{ marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {isLoading ? (
          <div style={{ 
            textAlign: 'center', 
            padding: '20px',
            color: '#666'
          }}>
            Signing in...
          </div>
        ) : (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            marginTop: '20px'
          }}>
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleError}
              useOneTap={false}
              text="signin_with"
              shape="rectangular"
              theme="outline"
              size="large"
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Login;
